module.exports = __webpack_public_path__ + "img/slide-gaadave.cf52fc3b.png";